import CLogger from '../logger/CLogger.js'
import db from './dexieDB';
const removePrefix = (key) => key.replace(/^persist:/, ''); // Remove "persist:"
const dexieStorage = {
  async getItem(key) {
    try {
      const tableName = removePrefix(key);
      if (!db[tableName]) {
        CLogger.warn(`Dexie storage: Table ${tableName} not found`);
        return null;
      }
      const result = await db[tableName].get(1);
      return result ? JSON.stringify(result.value) : null;
    } catch (error) {
      CLogger.error(`Error fetching data from Dexie (${key}):`, error);
      return null;
    }
  },
  async setItem(key, value) {
    try {
      const tableName = removePrefix(key);
      if (!db[tableName]) {
        CLogger.warn(`Dexie storage: Table ${tableName} not found`);
        return;
      }
      await db[tableName].put({ id: 1, value: JSON.parse(value) });
    } catch (error) {
      CLogger.error(`Error storing data in Dexie (${key}):`, error);
    }
  },
  async removeItem(key) {
    try {
      const tableName = removePrefix(key);
      if (!db[tableName]) {
        CLogger.warn(`Dexie storage: Table ${tableName} not found`);
        return;
      }
      await db[tableName].delete(1);
    } catch (error) {
      CLogger.error(`Error removing data from Dexie (${key}):`, error);
    }
  },
};

export default dexieStorage;


// import db from './dexieDB';
// const dexieStorage = {
//   async getItem(key) {
//     try{
//       if (db[key]) {
//       const result = await db[key].get(1); // Assuming the key has only one record (id: 1)
//       return result ? JSON.stringify(result.value) : null;
//       }
//     }
//     catch (error) {
//       console.error('Error fetching data from Dexie:', error);
//       return null;
//     }
    
//   },
//   async setItem(key, value) {
//     try{
//       if (db[key]) {
//       await db[key].put({ id: 1, value: JSON.parse(value) }); // Storing the updated value
//       }
//     }
//     catch (error) {
//       console.error('Error storing data in Dexie:', error);
//     }
//   },
//   async removeItem(key) {
//     try{
//       if (db[key]) {
//       await db[key].delete(1); // Remove the item from Dexie by id 1
//       }
//     }
//     catch (error) {
//       console.error('Error removing data from Dexie:', error);
//     }
//   },
// };
// // const dexieStorage = {
// //   getItem: async (key) => {
// //     try {
// //     const data = await db.persistStore.get(key);
// //     return data ? data.value : null;
// //     }
// //     catch(err){
// //       console.error("getItem error",err);
// //     }
// //   },
// //   setItem: async (key, value) => {
// //     try {
// //     await db.persistStore.put({ key, value });
// //     }
// //     catch(err){
// //       console.error("setItem error",err);
// //     }
// //   },
// //   removeItem: async (key) => {
// //     try {
// //     await db.persistStore.delete(key);
// //     }
// //     catch(err){
// //       console.error("removeItem error",err);
// //     }
// //   },
// // };


// export default dexieStorage;
